module.exports = __webpack_public_path__ + "img/typeEssence.b9e85ef0.svg";